<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Organization Name :</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text multi-line" [ngClass]="change| defineDomainViewCss: 'organizationName': 'contact'">
    {{organizationVO?.organizationName| displayValueFromChange :'organizationName': change :'contact'}}
  </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Physical address:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text multi-line" [ngClass]="change| defineDomainViewCss: 'address-streetAddress': 'contact'">
    {{organizationVO?.address.streetAddress| displayValueFromChange :'address-streetAddress': change :'contact'}}
  </div>
</div>
<div class="grid-x bold-text" *ngIf="
(organizationVO?.address.city| displayValueFromChange :'address-city': change :'contact') ||
(organizationVO?.address.state| displayValueFromChange :'address-state': change :'contact') ||
(organizationVO?.address.postalCode| displayValueFromChange :'address-postalCode': change :'contact')">
  <div class="cell large-4 medium-6 small-6"></div>
  <div class="cell medium-6 large-8 small-6">
        <span [ngClass]="change| defineDomainViewCss: 'address-city': 'contact'">
                  {{organizationVO?.address.city| displayValueFromChange :'address-city': change :'contact'}}
        </span>
    &nbsp;<span [ngClass]="change| defineDomainViewCss: 'address-state': 'contact'">
                {{organizationVO?.address.state| displayValueFromChange :'address-state': change :'contact'}}

      </span>
    &nbsp;<span [ngClass]="change| defineDomainViewCss: 'address-postalCode': 'contact'">
                {{organizationVO?.address.postalCode| displayValueFromChange :'address-postalCode': change :'contact'}}
      </span>
  </div>
</div>
<div class="grid-x bold-text">
  <div class="cell large-4 medium-6 small-6"></div>
  <div class="cell medium-6 large-8 small-6" [ngClass]="change| defineDomainViewCss: 'address-countryName': 'contact'">
    {{organizationVO?.address.countryName| displayValueFromChange :'address-countryName': change :'contact'}}

  </div>
</div>
<div class="grid-x last-update-button-section">
  <label>{{lastchange | lastChange}}</label>
  <button *ngIf="!viewMode" class="iana-button" name="edit" id="update" [disabled]="!(pendingRequestChangeID | checkNull) || !hasNonTechnicalPermission" (click)="onEdit()">Modify</button>
</div>
